
class GeneralVariables {
   
    static TOKEN_REFRESH_TIME_IN_MINUTES = window.config.VUE_APP_TOKEN_REFRESH_TIME_IN_MINUTES||process.env.VUE_APP_TOKEN_REFRESH_TIME_IN_MINUTES;

    static BACKEND = window.config.VUE_APP_BACKEND||process.env.VUE_APP_BACKEND;
    static BACKEND1 = window.config.VUE_APP_BACKEND1||process.env.VUE_APP_BACKEND1;
    static URL = window.config.VUE_APP_URL||process.env.VUE_APP_URL;

    static KEYCLOAK_REALM_AND_CLIENT_SUBDIRECTORY = window.config.VUE_APP_KEYCLOAK_REALM_AND_CLIENT_SUBDIRECTORY||process.env.VUE_APP_KEYCLOAK_REALM_AND_CLIENT_SUBDIRECTORY;

    static STRIPE_PUBLISHABLE_KEY = window.config.VUE_APP_STRIPE_PUBLISHABLE_KEY||process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;

    static VUE_APP_GEOLOCATION_API = window.config.VUE_APP_GEOLOCATION_API||process.env.VUE_APP_GEOLOCATION_API;

    static CHATBOT_URL = window.config.VUE_APP_CHATBOT_URL||process.env.VUE_APP_CHATBOT_URL;
}
export default GeneralVariables